import React from "react";
import { SubsectionWithFields } from "./subsection/fields";
import { SearchCommonField } from "../inputs/common-field";

export const PricesSection = () => {
    return (
        <>
            <SubsectionWithFields>
                <SearchCommonField name="prices.pricesOverall" />
                <div />
                <SearchCommonField name="prices.accomodation" />
                <SearchCommonField name="prices.mealRestaurant" />
                <SearchCommonField name="prices.entranceFees" />
                <SearchCommonField name="prices.mealShop" />
                <SearchCommonField name="prices.beer" />
                <SearchCommonField name="prices.coffee" />
                <SearchCommonField name="prices.flightTickets" />
                <SearchCommonField name="prices.flightOrigin" />
            </SubsectionWithFields>
        </>
    );
};
